/**
 * ECR (Engagement/Conversion/Retention) tracking.
 * Extends the existing trackEvent system by persisting to analytics_events table.
 */
import { trackEvent } from '@/lib/analytics';

export type ECREvent =
  | 'workout_logged'
  | 'duel_created'
  | 'duel_completed'
  | 'baseline_completed'
  | 'onboarding_completed'
  | 'session_start';

/**
 * Track an engagement event. Calls the existing trackEvent (which handles
 * console logging in dev + Supabase insert in prod) and ensures the event
 * is recorded with consistent naming.
 */
export function trackEngagement(event: ECREvent, metadata?: Record<string, any>) {
  trackEvent(event, metadata);
}
